import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useGetTasksQuery } from '../../features/tasks/tasksApi';
import SingleTaskRow from './SingleTaskRow';

const HomeMainContent = () => {
    const [shouldGetTask, setShouldGetTask] = useState(false)
    const { projects, searchText } = useSelector(state => state.filter)
    const { data: tasks, isLoading, isError, error } = useGetTasksQuery(undefined, { skip: !shouldGetTask })

    // decide what to render
    let content = null;

    if (isLoading) {
        content = <li className="m-2 text-center">Loading...</li>;
    } else if (!isLoading && isError) {
        content = (
            <div >Error something is wrong</div>
        );
    } else if (!isLoading && !isError && tasks?.length === 0) {
        content = <div className="m-2 text-center">No tasks found!</div>;
    } else if (!isLoading && !isError && tasks?.length > 0) {

        const filterProjectsShow = projects?.filter(single => single.show === true).map(single => single.projectName)
        // [projectName, projectName]
        const filterTaskWithProjects = tasks.filter(single => {
            return filterProjectsShow.includes(single?.project?.projectName)
        })
        let mainData = filterTaskWithProjects;
        if (searchText) {
            mainData = mainData.filter(single => single.taskName.toLowerCase().includes(searchText.toLowerCase()))
        }
        if (mainData.length) {

            content = mainData.map(single => <SingleTaskRow key={single.id} {...single}></SingleTaskRow>)
        } else {

            content = <div>No tasks found!</div>
        }
    }
    useEffect(() => {
        if (projects.length) {
            setShouldGetTask(true)
        }
    }, [projects])

    return (
        <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
            <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
                <div className="justify-between mb-10 space-y-2 md:flex md:space-y-0">
                    <Link to="/addNew" className="lws-addnew group">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" className="w-6 h-6 group-hover:text-indigo-500">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>

                        <span className="group-hover:text-indigo-500">Add New</span>
                    </Link>
                </div>

                <div className="lws-task-list">

                    {content}
                </div>
            </main>
        </div>
    );
};

export default HomeMainContent;